import React from 'react';

const NotificationsMenu = ({}) => {
  return (<></>);
};

export default NotificationsMenu;